module.exports = __webpack_public_path__ + "static/media/content_scanning.0c9f203b.mp3";